function doubleNumFn(num, isDoubleNum) {
    return isDoubleNum && num < 10 ? `0${num}` : num;
}

const DateUtil = {
    getAllDate(time, params = {}) {
        params = {
            isDoubleNum: params.isDoubleNum
        };
        const doubleNum = num => doubleNumFn(num, params.isDoubleNum);
        const date = new Date(time),
            year = date.getFullYear(),
            month = date.getMonth() + 1,
            day = doubleNum(date.getDate()),
            minutes = doubleNum(date.getMinutes()),
            hours = doubleNum(date.getHours()),
            seconds = doubleNum(date.getSeconds());
        return {year, month, day, hours, minutes, seconds};
    },
    /**
     * 获取整秒的时间
     * @param {number} time 时间戳
     */
    parseIntSeconds(time) {
        return parseInt(time / 1000) * 1000;
    },
    parseIntSecondsForSec(time) {
        const t = parseInt(time / 1000);
        if (!isNaN(t)) {
            return t;
        }
    },
    /**
     * 获取下一天的凌晨时间点
     * @param {number} time  时间戳
     * 比如传的time时间戳是 2019-9-9 10:00   返回 2019-9-10 00:00
     */
    getNextDayZero(time = +new Date()) {
        const curDate = this.getAllDate(time);
        return new Date(
            curDate.year,
            curDate.month - 1,
            Number(curDate.day) + 1,
            0,
            0
        ).getTime();
    },
    /**
     * 获取下一个小时的整点
     * @param {number} time
     */
    getNextHourZero(time) {
        const curDate = this.getAllDate(time);
        return new Date(
            curDate.year,
            curDate.month - 1,
            Number(curDate.day),
            Number(curDate.hours) + 1,
            0
        ).getTime();
    },
    /**
     * 获取下一个整的分钟
     * @param {number} time
     */
    getNextMinuteZero(time) {
        const curDate = this.getAllDate(time);
        return new Date(
            curDate.year,
            curDate.month - 1,
            curDate.day,
            curDate.hours,
            Number(curDate.minutes) + 1
        ).getTime();
    },
    /**
     * 获取当天的凌晨时间点，
     * @param {number} time  时间戳
     * 比如传的time时间戳是 2019-9-9 10:00   返回 2019-9-9 00:00
     */
    getCurrentDayZero(time = +new Date()) {
        const curDate = this.getAllDate(time);
        return new Date(
            curDate.year,
            curDate.month - 1,
            curDate.day,
            0,
            0
        ).getTime();
    },
    /**
     * 获取两个时间戳的差多少天，nextTime 为零点的时候，curTime为前一天的时候，返回0。
     * @param {number} curTime 当前时间戳
     * @param {number} nextTime 比较的时间戳
     * @param {number} isZeroForTomorrow true: 明天凌晨00:00 相对于今天时间 算1天   false: 明天凌晨00:00 相对于今天时间 算0天
     */
    getDuringDays(curTime, nextTime, opitons = {isZeroForTomorrow: true}) {
        const curTimeZero = this.getCurrentDayZero(curTime);
        const nextTimeZero = this.getCurrentDayZero(nextTime);
        let dayZero = 0; // 零点的时候，天减一
        if (nextTimeZero === nextTime && !opitons.isZeroForTomorrow) {
            dayZero = 1;
        }
        const days =
            this.getDuringTime(nextTimeZero - curTimeZero, {hasDay: true}).days -
            dayZero;
        return days > 0 ? days : 0;
    },

    /**
     * 获取时间差返回的，hour，minu，sec
     * @param {number} duringTime 时间差
     * @param {number} params 配置项
     * @param {boolean} params.isDoubleNum 是否返回一直双数 00
     * @param {boolean} params.hasDay 是否需要返回天
     */
    getDuringTime(duringTime, params = {}) {
        params = {
            isDoubleNum: params.isDoubleNum,
            hasDay: params.hasDay
        };
        const oneday = 1 * 24 * 60 * 60 * 1000;
        const onehour = 1 * 60 * 60 * 1000;
        const oneminute = 1 * 60 * 1000;
        const doubleNum = obj => {
            const res = {};
            if (params.hasDay) {
                res.days = doubleNumFn(obj.days, params.isDoubleNum);
            }
            res.hours = doubleNumFn(obj.hours, params.isDoubleNum);
            res.minutes = doubleNumFn(obj.minutes, params.isDoubleNum);
            res.seconds = doubleNumFn(obj.seconds, params.isDoubleNum);
            return res;
        };

        if (params.hasDay) {
            const days = parseInt(duringTime / oneday);
            const hours = parseInt((duringTime - days * oneday) / onehour);
            const minutes = parseInt(
                (duringTime - days * oneday - hours * onehour) / oneminute
            );
            const seconds = parseInt(
                (duringTime - days * oneday - hours * onehour - minutes * oneminute) /
                1000
            );
            return doubleNum({days, hours, minutes, seconds});
        } else {
            const hours = parseInt(duringTime / onehour);
            const minutes = parseInt((duringTime - hours * onehour) / oneminute);
            const seconds = parseInt(
                (duringTime - hours * onehour - minutes * oneminute) / 1000
            );
            return doubleNum({hours, minutes, seconds});
        }
    },

    /**
     * 两个时间点的时间戳 是否在同一天
     * @param {number} time1 时间戳
     * @param {number} time2 时间戳
     */
    isSameDay(time1, time2) {
        if (!time1 || !time2) {
            return false;
        }
        // 获取当天的凌晨的时间戳是否相等即可
        return this.getCurrentDayZero(time1) === this.getCurrentDayZero(time2);
    },

    /**
     * 判断传入的时间是否是今天（本地时间）的时间，
     * @param {number} time 时间戳
     */
    isSameCurrentDay(time) {
        if (!time) {
            return false;
        }
        const time1 = new Date().getTime();
        return this.isSameDay(time1, time);
    },
    /**
	 * @description: 获取N月有多少天
	 * @return {*}
	 * @acthor: Li Yong
	 * @Date: 2022-10-11 14:13:54
	 */
	getMonthNDays(n) {
		const lastMonth = new Date().setMonth(n);
		const monthFirstDay = new Date(new Date(lastMonth).setDate(0));
		// 获取day时需要month与当月月份数一致
		const day = new Date(monthFirstDay).getDate();
		return day;
	},
    /**
	 * @description: 获取n个自然月前到现在相距多少天，不算今天
	 * @param {*} n
	 * @return {*}
	 * @acthor: Li Yong
	 * @Date: 2022-10-24 13:43:11
	 */
	getLastNMonthDays(n) {
		const lastMonth = new Date().getMonth() - 1;
		const today = new Date();
		const numb = new Array(n).fill(0).reduce(total => (total += this.getMonthNDays(lastMonth + 2 - n--)), 0);
		const day = today.getDate();
		return numb + day - 1;
	},
    oneDayTimestamp: 3600 * 1000 * 24,
    oneDayTimeSec: 3600 * 24
};

export {DateUtil, doubleNumFn};
